import {
  DEFAULT_PAGE_SIZE,
  IS_EU,
  IS_SG,
  IS_TR,
  IS_UK,
  PROVIDER_COUNTRIES_FOR_SELF_BILLING,
} from 'common/constants/contstants';

export const ENABLE_INVOICE_INSTRUCTIONS = IS_EU;

export const ENABLE_FINANCE_PAGE = IS_EU || IS_UK || IS_SG;

export const ENABLE_FAST_PAY_PAGE = IS_TR;

export const ENABLE_XML_INVOICE_FORMAT = IS_EU;

export const isGstInFieldEnable = (country?: string | null) => country === 'India';

export const isSelfBillingEnable = (country?: string | null) => {
  if (!country) {
    return false;
  }

  if (IS_SG) {
    return true;
  }

  if (IS_TR) {
    return false;
  }

  if (IS_UK) {
    return true;
  }

  return PROVIDER_COUNTRIES_FOR_SELF_BILLING.includes(country);
};

export const ENABLE_PRICE_FILTER_SORT = IS_TR;

const JOB_OFFERS_QUANTITY_LIMIT_IN_TR = 100;

export const JOB_OFFERS_QUANTITY_LIMIT = IS_TR ? JOB_OFFERS_QUANTITY_LIMIT_IN_TR : DEFAULT_PAGE_SIZE;
